import { Info } from "lucide-react";
import { scoreBg } from "@/lib/format";

export function ScoreBadge({ score, label = "", size = "md", testid }) {
  const sz = size === "lg" ? "text-3xl px-4 py-2" : size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-2.5 py-1";
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 font-mono tabular-nums border rounded-sm ${scoreBg(score)} ${sz}`}
    >
      {label && <span className="opacity-70 font-sans text-xs uppercase tracking-wider">{label}</span>}
      <span className="font-semibold">{score}</span>
    </span>
  );
}

export function ScoreRing({ score, label = "CF Readiness", testid }) {
  return (
    <div className="flex items-center gap-4">
      <div
        className="score-ring h-24 w-24 rounded-full flex items-center justify-center"
        style={{ "--score": score }}
      >
        <div className="relative z-10 text-center">
          <div className="font-mono font-bold text-2xl text-emerald-400 tabular-nums" data-testid={testid}>
            {score}
          </div>
          <div className="text-[10px] uppercase tracking-wider text-slate-500">/ 100</div>
        </div>
      </div>
      <div className="flex items-center gap-1.5 text-xs uppercase tracking-widest text-slate-400">
        <span>{label}</span>
        <span
          tabIndex={0}
          data-testid="ai-score-info"
          title="CF Readiness Score (v2.1) ,  6-dimension rules-based score across motivation, life events, receptivity, viability, accessibility and freshness. Compound-signal bonuses stack on top. This value drives pipeline stage advancement, hot-lead alerts and the verified-owner-direct badge."
          className="cursor-help text-slate-500 hover:text-emerald-300 transition-colors"
        >
          <Info className="h-3 w-3" />
        </span>
      </div>
    </div>
  );
}
